import { createApp } from '@backstage/frontend-defaults';
import {
  sulmaraLightThemeExtension,
  sulmaraDarkThemeExtension,
} from './theme/sulmaraTheme';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { customFluxModule, customFluxAppModule } from './modules/flux';
import { systemInfoModule } from './modules/system-info';
import techDocsMermaidAddonModule from 'backstage-plugin-techdocs-addon-mermaid/alpha';

import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageProps } from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';
import {
  oidcAuthApiRef,
  oidcAuthApi,
  gitlabAuthApi,
  kubernetesAuthProvidersApi,
} from './apis';

const oidcSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => (props: SignInPageProps) =>
      (
        <SignInPage
          {...props}
          auto
          providers={[
            {
              id: 'oidc',
              title: 'Sulmara OIDC',
              message: 'Sign in using Entra ID',
              apiRef: oidcAuthApiRef,
            },
          ]}
        />
      ),
  },
});

const customSignInPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    oidcSignInPage,
    oidcAuthApi,
    gitlabAuthApi,
    sulmaraLightThemeExtension,
    sulmaraDarkThemeExtension,
  ],
});

const customKubernetesAuthModule = createFrontendModule({
  pluginId: 'kubernetes',
  extensions: [kubernetesAuthProvidersApi],
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    customSignInPageModule,
    customKubernetesAuthModule,
    customFluxModule,
    customFluxAppModule,
    systemInfoModule,
    techDocsMermaidAddonModule,
  ],
});
